import React from "react";

const CarouselImage = ({ src, alt }) => {
  return <img className="carousel-image" src={src} alt={alt} />;
};

export default CarouselImage;
